<template>
  <base-modal
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :is-editable="false"
    :is-archivable="false"
  >
    <template #header>
      {{$t('views.excmnote.create.title')}}
    </template>
    <template #body>
      <create
        :id-firm="idFirm"
        :id-case="idCase"
        :id-organization-lead="idOrganizationLead"
      ></create>
    </template>
  </base-modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import BaseModal from '@/components/BaseComponents/BaseModal'
import Create from '@/components/Dashboard/Views/excmnote/Create'

export default {
  name: 'AddNoteModal',
  components: {
    Create,
    BaseModal
  },
  props: ['idFirm', 'idCase', 'idOrganizationLead'],
  computed: {
    ...mapGetters({
      isVisible: 'excmnote/createModal/getIsVisible',
      created: 'excmnote/create/created'
    })
  },
  watch: {
    created (val) {
      if (val) this.toggleModal()
    }
  },
  methods: {
    hideModal () {
      this.reset()
      this.toggleModal()
    },
    ...mapActions({
      reset: 'excmnote/create/reset'
    }),
    ...mapMutations({
      toggleModal: 'excmnote/createModal/toggleModal'
    })
  }
}
</script>

<style scoped>

</style>
